module.exports = __webpack_public_path__ + "static/media/three_dots.5c6367fb.svg";